export default __webpack_public_path__ + "static/MediaContentNine-2e398dc96114ed2b3098920a9e15d1d4.webp";